webpackJsonp([14],{

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configClass", function() { return configClass; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_messaging__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_analytics__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__main__ = __webpack_require__(2);













var configClass = function () {
  function configClass() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, configClass);

    this._config = null;
    this._vendorid = null;
    this._vendorkey = null;
    //
    this.loadConfig();
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(configClass, [{
    key: "loadConfig",

    /**
     * @desc This method will load configuration.
     */
    value: function loadConfig() {
      var _this = this;

      // prod - https://s3.amazonaws.com/conf.vlite.com/sdgr/prod-config.json - change facebook id
      // pre prod - https://s3.amazonaws.com/conf.vlite.com/sdgr/preprod-config.json

      // previously used - https://s3.amazonaws.com/conf.vlite.com/sdgr/v1/prod-config.json

      fetch("https://sdg-preprod.firebaseio.com/config/jPa6e0sh.json?print=pretty", {
        method: "GET"
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        // console.log("++++++++++++++config-details++++++++++++++", data);
        _this._config = data;
        _this._vendorid = data.vendor.vendorid;
        _this._vendorkey = data.vendor.vendorkey = "yuZjz1lenAs0Fcsh"; // data.vendorkey
        //
        _this.initAppTheme();
        //
        // EventBus.$emit("configLoaded");
        //
        __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch("actLocate").then(function (response) {
          if (response.success) {
            var country = response.success;
            // console.log('============country===============', country);
            localStorage.setItem("country", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(country));
            // Commit Country
            __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit("commitCountry", country);

            // EventBus.$emit('configLoaded')
          }
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_9__main__["EventBus"].$emit("signupError", error);
        });
        // //
        _this.initAppCycle();
        _this.fetchVendorInfo();
        //
        __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 514)).then(function (user) {
          _this.user = new user.userClass();
        });
      }).catch(function (error) {
        console.log("[error]", error);
      });
    }
    /**
     * @desc This method acts as the main execution entry of the Entire App.
     */

  }, {
    key: "initAppCycle",
    value: function initAppCycle() {
      this.initAppFirebase();
      this.initFacebookSDK();
    }
    /**
     * @desc This method will fetch the App Configuration which includes the vendor and theme information which we need to store in the local storage which later will be used in different parts of the App.
     */

  }, {
    key: "initAppTheme",
    value: function initAppTheme() {
      // Setting AppConfig to local storage
      localStorage.setItem("AppConfig", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this._config));
    }
  }, {
    key: "initAppFirebase",
    value: function initAppFirebase() {
      // Check how many instance of firebase app has been registered. If already registered then apps.length will return >0. Then no need to register again.
      if (__WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.apps.length) return;

      var firebaseConfig = {
        apiKey: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_API_KEY,
        authDomain: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_AUTH_DOMAIN,
        databaseURL: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_DATABASE_URL,
        projectId: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_PROJECT_ID,
        storageBucket: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_STORAGE_BUCKET,
        messagingSenderId: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_MESSAGING_SENDER_ID,
        appId: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FCM_APP_ID
      };
      __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.initializeApp(firebaseConfig);

      // secondary Firebase - Only For GA
      var secondaryAppConfig = {
        apiKey: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_API_KEY2,
        authDomain: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_AUTH_DOMAIN2,
        databaseURL: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_DATABASE_URL2,
        projectId: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_PROJECT_ID2,
        storageBucket: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_STORAGE_BUCKET2,
        messagingSenderId: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_MESSAGING_SENDER_ID2,
        appId: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FCM_APP_ID2,
        measurementId: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FIRE_MEASUREMENT_ID2
      };
      __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.initializeApp(secondaryAppConfig, "secondary");
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit("CommitUserStore");
      // this.initFCMNotifications();
      //
      __WEBPACK_IMPORTED_MODULE_9__main__["EventBus"].$emit("configLoaded");
    }
  }, {
    key: "initFCMNotifications",
    value: function initFCMNotifications() {
      // Retrieve Firebase Messaging object.
      var secondary = __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.app("secondary");
      var messaging = secondary.messaging();
      // Add the public key generated from the console here.
      messaging.usePublicVapidKey(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.FCM_CERTIFICATE_KEY2);

      if (navigator.serviceWorker) {
        navigator.serviceWorker.register("static/sw.js").then(function (registration) {
          messaging.useServiceWorker(registration);

          messaging.requestPermission().then(function (res) {
            messaging.getToken().then(function (token) {
              // let url = `${store.getters.FCM_BASE_URL2}/${token}/rel/topics/${store.getters.FCM_TOPIC_NAME_PREFIX}${store.getters.vendorid}`;

              // console.log("[firebase url]", url);

              // fetch(url, {
              //   method: "POST",
              //   headers: new Headers({
              //     Authorization: `key=${store.getters.FCM_SERVER_KEY2}`
              //   })
              // })
              //   .then(() => {
              //     console.log("[Vendor Topics Subscribed]");
              //   })
              //   .catch(error => {
              //     console.log("[error]", error);
              //   });
              // const listenToSubscriberNotification = () => {
              //   let subscriberUrl = `${store.getters.FCM_BASE_URL2}/${token}/rel/topics/${store.getters.FCM_TOPIC_NAME_PREFIX}${store.getters.vendorid}_${store.getters.subscriberid}`;

              //   console.log("[subscriberUrl]", subscriberUrl);

              //   fetch(subscriberUrl, {
              //     method: "POST",
              //     headers: new Headers({
              //       Authorization: `key=${store.getters.FCM_SERVER_KEY2}`
              //     })
              //   })
              //     .then(response => {
              //       console.log("[Subscriber Topics Subscribed]");
              //     })
              //     .catch(error => {});
              // };
              // if (store.getters.subscriberid) {
              //   listenToSubscriberNotification();
              // }
              localStorage.setItem("messageToken", token);
              // notification
              var notificationStatus = localStorage.getItem("notificationStatus");
              // console.log("notificationStatus", notificationStatus);
              if (notificationStatus !== null && JSON.parse(notificationStatus)) {
                __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch("subscribeVendorAndSubscriberTopics");
              } else {
                if (notificationStatus === null) {
                  localStorage.setItem("notificationStatus", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(true));
                  __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch("subscribeVendorAndSubscriberTopics");
                }
              }
            }).catch(function (err) {
              console.log("[err]", err);
            });
          }).catch(function (err) {
            console.log("[err]", err);
          });
          // firebase.notifications().onNotification(notification => {
          //   console("Inside notification", notification);
          // });
          messaging.onMessage(function (payload) {
            // console.log("[onMessage payload]", payload);
            //if (!store.getters.AppUser) return;

            var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, {
              read: false,
              timestamp: new Date()
              // timestamp: Math.floor(new Date().getTime() / 1000)
            });
            var fcm_notifications = localStorage.getItem("fcm_notifications");
            var notifications = void 0;
            if (fcm_notifications) {
              notifications = JSON.parse(fcm_notifications);
              notifications = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(notifications), [data]);
            } else {
              notifications = [data];
            }
            notifications = notifications.slice().reverse();

            localStorage.setItem("fcm_notifications", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(notifications));
            __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit("commitFCMNotifications", true);

            if (Notification.permission === "granted") {
              var _data = payload.data;
              var title = "SDG Notification";
              var body = "New message from SDG";
              var image = null;
              if (payload.data) {
                title = _data.title;
                body = _data.message;
                image = _data.image_url;
              }
              var options = {
                body: body,
                image: image
              };
              registration.showNotification(title, options);
            }
          });
        }, function (error) {
          console.log("sw not reg", error);
        });
      }
    }
  }, {
    key: "initFacebookSDK",
    value: function initFacebookSDK() {
      window.fbAsyncInit = function () {
        FB.init({
          // appId      : '1080582505471223',
          // appId: "1303739023127392", // test
          appId: "1024039847941842", // live
          // appId: "228226828540122", //myid
          cookie: true,
          xfbml: true,
          version: "v6.0"
        });
      };
      (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.async = true;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        // js.src ="//connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v4.0&appId=511762009638895";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    }
  }, {
    key: "fetchVendorInfo",
    value: function fetchVendorInfo() {
      localStorage.setItem("AppVendor", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this._config.vendor));
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit("CommitVendorStore");
      // Initializing vLive Analytics SDK
      this.initvLiveWebSdk();
      // Defined in Vendor.js Store Module
      // store.dispatch('actGetVendorInfo').then(response => {
      //   if (!response.error) {
      //     // Set the vendor config data to local storage
      //     localStorage.setItem('AppVendor', JSON.stringify(response));
      //     store.commit('CommitVendorStore');

      //     // Initializing vLive Analytics SDK
      //     this.initvLiveWebSdk();
      //   }
      // }).catch(error => {
      //   EventBus.$emit('configError',error)
      //   console.log('[App] getVendorInfo error', error);
      // });
    }
  }, {
    key: "fetchCountry",
    value: function fetchCountry() {
      // get country code
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch("actLocate").then(function (response) {
        if (response.success) {
          // console.log("actLocate", response);
          var country = response.success;
          localStorage.setItem("country", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(country));
          // Commit Country
          __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit("commitCountry", country);
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_9__main__["EventBus"].$emit("signupError", error);
      });
    }
  }, {
    key: "initvLiveWebSdk",
    value: function initvLiveWebSdk() {
      var _this2 = this;

      // Check for value in vendorid & vendorkey
      if (!(this._vendorid && this._vendorkey)) return;

      __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 515)).then(function (VLiveBaseSdk) {
        var vLiveWebSdk = new VLiveBaseSdk(_this2._vendorid, _this2._vendorkey);

        // Set the analytics SDK Object to global window object
        window.vLiveWebSdk = vLiveWebSdk;
      });
    }
  }, {
    key: "config",
    get: function get() {
      return this._config;
    }
  }, {
    key: "vendorid",
    get: function get() {
      return this._vendorid;
    }
  }, {
    key: "vendorkey",
    get: function get() {
      return this._vendorkey;
    }
  }]);

  return configClass;
}();

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(238);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(239), __esModule: true };

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
__webpack_require__(240);
module.exports = __webpack_require__(3).Array.from;


/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(21);
var $export = __webpack_require__(9);
var toObject = __webpack_require__(39);
var call = __webpack_require__(76);
var isArrayIter = __webpack_require__(77);
var toLength = __webpack_require__(38);
var createProperty = __webpack_require__(241);
var getIterFn = __webpack_require__(78);

$export($export.S + $export.F * !__webpack_require__(79)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(14);
var createDesc = __webpack_require__(37);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ })

});


// WEBPACK FOOTER //
// static/js/14.a59d7094636531313aec.js